// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d111efdb","498":"6362e4b2","513":"02c453e8"}[chunkId] + ".chunk.js";
};